/**
 *
 */
export default function () {
  return {
    /** @type {object} Выбранные фильтры в списке Issue */
    filter: {
      pos: { id: null, name: '', phones: [], address: '' }, // выбрана конкретная точка
      has_pos: [], // есть ли ТТ: 'true', 'false' (строкой для корректной обработки)
      is_completed: [], // закрыт ли запрос: 'true', 'false' (строкой для корректной обработки)
      is_started: [], // начат визит
      assigned_user: [], // назначено на сотрудников
      assigned_group: [], // назначено на группу
      assigned_all_in_group: [], // назначено на пользователей из группы
      participants: [], // участники
      labels: [], // метки, элементы в формате {label_id, category}
      has_reminder: [], // есть ли напоминания: 'true', 'false' (строкой для корректной обработки)
      has_overdue: [], // просрочено
      event_actions: [], // типы событий запроса
      sector: [], // сектор
      ts: [], // ts
      channels: [], // канал ТТ
      warehouses: [] // склады
    },
    sorting: {
      key: 'default', // default pos_name pos_trading_name
      value: 'desc'
    },
    filterSearch: null, // поиск по запросам
    filterDate: { from: null, to: null }, // дата запросов
    filterCompletedDate: { from: null, to: null },
    /** @type {object} Выбранные фильтры в списке Calls */
    call: {
      orgStructure: null
    },
    // Оператор в статусе звонка или в дозвоне (если в звонке - инфо по ТТ)
    callInProgress: null,
    // текущий провайдер пользователя
    provider: null,
    // Колонки в issue
    leftSide: 20,
    rightSide: 40,
    // Статус оператора - позиция и состояние
    osPosition: [0, 0],
    osDirection: 'down',
    osExpanded: true,
    // Карта
    mapZoom: 2, // Выбранный формат отображения развернутый/свернутый
    // Заказы
    orderZoom: 1, // Выбранный формат отображения формы заказа развернутый/свернутый
    orderColumns: [] // Выбранные для отображения колонки в форме заказа
  }
}
